export const ACCOUNTANTS_USER_TYPE_ID = 99
